import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

let echoInstance = null;

Object.defineProperty(window, 'Echo', {
    get() {
        if (!echoInstance) {
            echoInstance = new Echo({
                broadcaster: 'reverb',
                key: import.meta.env.VITE_REVERB_APP_KEY,
                wsHost: import.meta.env.VITE_REVERB_HOST ?? window.location.hostname,
                wsPort: import.meta.env.VITE_REVERB_PORT ? Number(import.meta.env.VITE_REVERB_PORT) : 8080,
                wssPort: import.meta.env.VITE_REVERB_PORT ? Number(import.meta.env.VITE_REVERB_PORT) : (window.location.protocol === 'https:' ? 443 : 8080),
                forceTLS: window.location.protocol === 'https:',
                enabledTransports: ['ws', 'wss'],
            });
        }
        return echoInstance;
    },
    set(value) {
        echoInstance = value;
    },
    configurable: true,
});